// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full__border[data-v-613ffcb8]{border:2px solid #c4c4c4;border-radius:1rem}.discounted[data-v-613ffcb8]{text-decoration:line-through}", ""]);
// Exports
module.exports = exports;
